import { render, staticRenderFns } from "./signDetail.vue?vue&type=template&id=636bcdbd&scoped=true"
import script from "./signDetail.vue?vue&type=script&lang=js"
export * from "./signDetail.vue?vue&type=script&lang=js"
import style0 from "./signDetail.vue?vue&type=style&index=0&id=636bcdbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636bcdbd",
  null
  
)

export default component.exports